module.exports = __webpack_public_path__ + "skillsCover.9da7bfed3575feeee0aa.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/skillsCover.jpg
// module id = ../../../../../src/assets/coverPicks/skillsCover.jpg
// module chunks = 0